module.exports = __webpack_public_path__ + "img/Arrow up Icon - white.e32ce004.svg";